<input class="eveInput"
       [(ngModel)]="eveModel"
       [placeholder]="placeholder"
       (keyup)="onAddTitle()">

<ng-container *ngIf="validationTemplate != null">
  <ng-container *ngTemplateOutlet="validationTemplate"></ng-container>
</ng-container>
